import { render, staticRenderFns } from "./StudentForm.vue?vue&type=template&id=c1a5461a&scoped=true"
import script from "./StudentForm.vue?vue&type=script&lang=js"
export * from "./StudentForm.vue?vue&type=script&lang=js"
import style0 from "./StudentForm.vue?vue&type=style&index=0&id=c1a5461a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a5461a",
  null
  
)

export default component.exports